// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1RdQ8","label":"Radio_label__3D102","checkMark":"Radio_checkMark__pOtiH","disabled":"Radio_disabled__357t7"};